<script setup lang="ts">
const props = defineProps<{
  video: {
    shortPlayerLink: string;
    longLink: string;
    longVideoText: string;
    time: string;
  };
  themeKeys: {
    buttonBg: string;
    buttonFg: string;
    icon: string;
  };
}>();
</script>

<template>
  <div class="outer-container">
    <div class="relative inner-container">
      <div
        class="w-full aspect-2/1 border"
        @click="() => navigateTo(props.video.longLink, { open: { target: '_blank' } })"
      >
        <video
          :src="props.video.shortPlayerLink"
          height="100%"
          width="100%"
          controls autoplay muted loop
          controlsList="nodownload nofullscreen noremoteplayback"
        >
        </video>
      </div>
      <a
        :href="props.video.longLink"
        class="absolute -bottom-5 right-6 lg:right-16 p-4 rounded-3xl flex flex-row items-center gap-2 hover:shadow-xl cursor-pointer transition"
        :style="{
          backgroundColor: props.themeKeys.buttonBg,
          color: props.themeKeys.buttonFg,
        }"
      >
        <Icon
          name="lucide:circle-play"
          class="size-6"
          :style="{ color: props.themeKeys.icon }"
        />
        <span class="font-semibold">
          {{ props.video.longVideoText }}
        </span>
        {{ props.video.time }}
      </a>
    </div>
  </div>
</template>
